export function timeline() {
    const $element = $(".timeline-section");
    const $line = $(".line");
    const $window = $(window);
    const $timeLineList = $(".timeline-list");
    $window.on("scroll", function () {
        const $elementTop = $element.offset().top - 1000;
        const $listHeight = $timeLineList.outerHeight();
        const $listTop = $timeLineList.offset().top;
        const $listBottom = $listTop + $listHeight;
        const $scrollPosition = $window.scrollTop() - $elementTop;
        if ($scrollPosition >= 0) {
            $line.addClass("active");
        } else {
            $line.removeClass("active");
        }
        if ($window.scrollTop() > $listBottom) {
            $line.removeClass("active");
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/timeline.js